import { ApiError } from '../live/api.ts';

export type DraftRefresh = 'reset' | 'preserve' | 'conflict';

/** Stable comparison token for the server fields an editor started from. */
export function ticketDraftSnapshot(...fields: unknown[]): string {
  return JSON.stringify(fields);
}

/** Decide whether incoming ticket detail may replace an editor's local draft. */
export function reconcileTicketDraft(input: {
  dirty: boolean;
  draftTicketKey: string;
  draftVersion: number;
  incomingTicketKey: string;
  incomingVersion: number;
  draftSnapshot: string;
  incomingSnapshot: string;
}): DraftRefresh {
  if (input.draftTicketKey !== input.incomingTicketKey || !input.dirty) return 'reset';
  if (input.draftVersion !== input.incomingVersion) return 'conflict';
  return input.draftSnapshot === input.incomingSnapshot ? 'preserve' : 'conflict';
}

/** Ticket writes use 409 for optimistic-concurrency refusals. */
export function isTicketDraftConflict(error: unknown): boolean {
  return error instanceof ApiError && error.status === 409;
}
